<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :cols="cols"
        :form-context="formContext"
        icon="inticon-autoclaim_company_group"
        title="Zuweisungen"
        @save="saveFirmAssignments">
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Haftpflicht-Rechtsanwälte"
                :options-loader="loadLawyersOptions"
                property="casualtyLawyers"
                type="multiselectsearchable"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Kasko-Rechtsanwälte"
                :options-loader="loadLawyersOptions"
                property="comprehensiveLawyers"
                type="multiselectsearchable"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Inkasso-Rechtsanwälte"
                :options-loader="loadLawyersOptions"
                property="debtCollectionLawyers"
                type="multiselectsearchable"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Regress-Rechtsanwälte"
                :options-loader="loadLawyersOptions"
                property="regressLawyers"
                type="multiselectsearchable"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Abweichende Reparaturbetriebe"
                :options-loader="loadDifferingRepairFirmsOptions"
                property="differingRepairFirms"
                type="multiselectsearchable"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="KARO-Lack"
                :options-loader="loadPaintShopsOptions"
                property="paintShops"
                type="multiselectsearchable"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Logistiker"
                :options-loader="loadLogisticiansOptions"
                property="logisticians"
                type="multiselectsearchable"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Aufbereiter"
                :options-loader="loadDetailersOptions"
                property="detailers"
                type="multiselectsearchable"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Mietwagenunternehmen"
                :options-loader="loadCarRentalCompaniesOptions"
                property="carRentalCompanies"
                type="multiselectsearchable"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Callcenter"
                :options-loader="loadCallcenterOptions"
                property="callcenter"
                type="autocomplete"/>
        </b-row>
    </csp-desktop-info-card>
</template>

<script>
    import Container from '@services/Container';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';

    const container = Container.getInstance();
    const firmRepository = container.getDesktopFirmRepository();

    export default {
        name: 'FirmAssignments',
        mixins: [FormDataMixin],
        props: {
            cols: {
                type: Number,
                default: 12,
            },
        },
        computed: {
            firmId() {
                return this.$route.params.firmId;
            },
        },
        methods: {
            loadCallcenterOptions() {
                return firmRepository.getCallcenterOptions(this.firmId);
            },
            loadCarRentalCompaniesOptions() {
                return firmRepository.getCarRentalCompaniesOptions(this.firmId);
            },
            loadDetailersOptions() {
                return firmRepository.getDetailersOptions(this.firmId);
            },
            loadDifferingRepairFirmsOptions() {
                return firmRepository.getDifferingRepairFirmsOptions(this.firmId);
            },
            loadLawyersOptions() {
                return firmRepository.getLawyersOptions(this.firmId);
            },
            loadLogisticiansOptions() {
                return firmRepository.getLogisticiansOptions(this.firmId);
            },
            loadPaintShopsOptions() {
                return firmRepository.getPaintShopsOptions(this.firmId);
            },
            saveFirmAssignments(formContext) {
                const saveFunction = (objectId, postData) => {
                    return firmRepository.saveFirmAssignments(objectId, postData);
                };
                this.saveFormData(formContext, saveFunction);
            },
            /** Discards any unsaved changes to form values */
            reload() {
                const reloadFunction = () => {
                    return firmRepository.reloadFirmAssignments(this.firmId);
                }
                this.reloadFormData(this.formContext, reloadFunction);
            },
        },
    }
</script>
